import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Button } from '@sololearnorg/sol';

import s from './Benefits.scss';

interface IBenefitsProps {
    onClick: () => void;
}

export function Benefits({ onClick }: IBenefitsProps) {
	useStyles(s);

	return (
		<div className="sl-teams-benefits">
			<div className="sl-teams-benefits__header">
				<div className="sl-teams-benefits__header__title">
					Grow your people → grow your business
				</div>
				<div className="sl-teams-benefits__header__subtitle">
					Maximize on your investment into your employees. Upskill,
					reskill and close skill gaps in the in-demand skills that
					truly benefit your company!
				</div>
				<Button onClick={onClick}>Start today</Button>
			</div>

			<div className="sl-teams-benefits__container">
				<div className="sl-teams-benefits__item">
					<div className="sl-teams-benefits__item__image">
						<img
							src="https://blob.sololearn.com/web-assets/teams-benefit-1.png"
							alt="teams-benefit-1"
						/>
					</div>
					<div className="sl-teams-benefits__item__text">
						<div className="sl-teams-benefits__item__text__title">
							Anticipate change
						</div>
						<div className="sl-teams-benefits__item__text__description">
							Stay competitive, innovative, and
							<b> ride changing business priorities with ease </b>
							when your workforce is equipped in skills like
							Python, AI, Angular, and more.
						</div>
					</div>
				</div>
				<div className="sl-teams-benefits__item">
					<div className="sl-teams-benefits__item__image">
						<img
							src="https://blob.sololearn.com/web-assets/teams-benefit-2.png"
							alt="teams-benefit-2"
						/>
					</div>
					<div className="sl-teams-benefits__item__text">
						<div className="sl-teams-benefits__item__text__title">
							Make stronger decisions
						</div>
						<div className="sl-teams-benefits__item__text__description">
							When everyone in your company can understand,
							visualize, and analyze data effectively, you’ll see
							better,
							<b> data-driven </b>
							decisions that bring direct
							results.
						</div>
					</div>
				</div>
				<div className="sl-teams-benefits__item">
					<div className="sl-teams-benefits__item__image">
						<img
							src="https://blob.sololearn.com/web-assets/teams-benefit-3.png"
							alt="teams-benefit-3"
						/>
					</div>
					<div className="sl-teams-benefits__item__text">
						<div className="sl-teams-benefits__item__text__title">
							Demonstrate your ROI
						</div>
						<div className="sl-teams-benefits__item__text__description">
							Use your secure, custom dashboard to visualize your
							employees’ learning progress and their
							<b> newly obtained skills, </b>
							and distribute your
							budget for optimal ROI.
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
